// extracted by mini-css-extract-plugin
var _1 = "bpl__leaderboard-selector__PBfvA";
var _2 = "bpl__leaderboard-selector__tabs__item__GKpSL";
var _3 = "bpl__leaderboard-selector__tabs__item__data__vkq5I";
var _4 = "bpl__leaderboard-selector__tabs__item__data__subtitle__e844H";
var _5 = "bpl__leaderboard-selector__tabs__item__data__title__pMqhR";
var _6 = "bpl__leaderboard-selector__tabs__item__logo__YJFDL";
export { _1 as "leaderboard-selector", _2 as "leaderboard-selector__tabs__item", _3 as "leaderboard-selector__tabs__item__data", _4 as "leaderboard-selector__tabs__item__data__subtitle", _5 as "leaderboard-selector__tabs__item__data__title", _6 as "leaderboard-selector__tabs__item__logo" }
